import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';

const useArchiveStandardizationProject = () => {
  const queryClient = useQueryClient();
  const { mutate, isLoading } = useMutation(async (id) => {
    return await axios.post(`/standardization/${id}/archive`);
  });

  const archiveProject = (projectId, { onSuccess, onSettled }) => {
    mutate(projectId, {
      onSuccess: (res) => {
        if (!res.data) {
          toast.error(`The project can not be archived!`);
          return;
        }

        queryClient.invalidateQueries('standardizationProjects', { exact: true });
        queryClient.invalidateQueries('archivedStandardizationProjects', { exact: true });

        toast.success(`Successfully archived! `);

        onSuccess && onSuccess(projectId);
      },
      onError: (err) => {
        toast.error(err.message || 'Error! Try again later.');
      },
      onSettled: () => onSettled && onSettled(),
    });
  };

  return {
    archiveProject,
    isLoading,
  };
};

export default useArchiveStandardizationProject;
